/**
 * Splash — a primeira coisa que aparece ao abrir o app.
 *
 * Cobre a janela entre abrir e saber se há sessão. Fundo do tema (claro por
 * padrão — teste físico, item 1), a marca inteira e uma barra de progresso.
 * A barra não mede nada de verdade: caminha até quase o fim enquanto a
 * sessão é conferida e fecha quando a resposta chega; é o que faz a espera
 * parecer curta em vez de travada. Não depende de rede para desenhar: pode
 * ser a primeira tela de uma PWA aberta sem sinal.
 */
import { Logo } from '../../ui/Logo';

export function SplashScreen({ concluindo = false }: { concluindo?: boolean }) {
  return (
    <section className="auth-splash" role="status" aria-live="polite" aria-busy={!concluindo} data-testid="splash">
      <Logo largura={240} className="auth-splash__logo" />
      <div className="auth-splash__barra" aria-hidden="true">
        <span className={`auth-splash__progresso${concluindo ? ' auth-splash__progresso--fim' : ''}`} />
      </div>
      <span className="nv-visually-hidden">Carregando</span>
    </section>
  );
}
